import UserIdentificationView from './user-identification-view';

export default UserIdentificationView;
export { UserIdentificationView };
